module.exports = __webpack_public_path__ + "static/media/person_3.514eee1b.jpg";